module.exports = __webpack_public_path__ + "img/service3_content.2249871b.png";